module.exports = __webpack_public_path__ + "img/1.9290694b.jpg";